import React from 'react';
import styled from 'styled-components';
import { Section, Container, BlockTitle, t } from '../styles/shared';

const VideoWrap = styled.div`
  position: relative; width: 100%; max-width: 900px; margin: 0 auto;
  background: #000; border-radius: 8px; overflow: hidden;
  ${({ $ratio }) => $ratio === '16:9' && 'aspect-ratio: 16 / 9;'}
  ${({ $ratio }) => $ratio === '4:3'  && 'aspect-ratio: 4 / 3;'}
  ${({ $ratio }) => $ratio === '1:1'  && 'aspect-ratio: 1 / 1;'}
  iframe, video {
    position: absolute; top: 0; left: 0; width: 100%; height: 100%;
  }
`;

const Placeholder = styled.div`
  display: flex; align-items: center; justify-content: center;
  height: 100%; color: #666; position: absolute; inset: 0;
`;

const CaptionText = styled.p`
  margin-top: 12px; font-size: 0.875rem; color: ${t.textLight}; text-align: center;
`;

const getEmbed = (url, autoplay, muted) => {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]+)/);
  if (yt) {
    const p = new URLSearchParams();
    if (autoplay) p.set('autoplay', '1');
    if (muted) p.set('mute', '1');
    return `https://www.youtube.com/embed/${yt[1]}?${p}`;
  }
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) {
    const p = new URLSearchParams();
    if (autoplay) p.set('autoplay', '1');
    if (muted) p.set('muted', '1');
    return `https://player.vimeo.com/video/${vm[1]}?${p}`;
  }
  return url;
};

const VideoBlock = ({ content = {}, settings = {} }) => {
  const { url = '', title = '', caption = '', aspectRatio = '16:9', autoplay = false, muted = false } = content;
  const { backgroundColor = '', padding = 'large' } = settings;
  const embed = getEmbed(url, autoplay, muted);
  const isDirect = embed && /\.(mp4|webm|ogg)$/.test(embed);

  return (
    <Section $padding={padding} $bgColor={backgroundColor}>
      <Container>
        {title && <BlockTitle style={{ textAlign: 'center' }}>{title}</BlockTitle>}
        <VideoWrap $ratio={aspectRatio}>
          {isDirect
            ? <video src={embed} controls autoPlay={autoplay} muted={muted} playsInline />
            : embed
              ? <iframe src={embed} title={title || 'Video'} frameBorder="0" allowFullScreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
              : <Placeholder><p>Video URL not configured</p></Placeholder>
          }
        </VideoWrap>
        {caption && <CaptionText>{caption}</CaptionText>}
      </Container>
    </Section>
  );
};

export default VideoBlock;
